import type { VoidFunctionComponent } from 'react';
import Sidebar from '../shared/components/Sidebar';
import type { ReportGenerationParams } from '../../shared/types';

type Props = {
  params: ReportGenerationParams;
  resetFormat: () => void;
};

const ReleaseGroupLevelSidebar: VoidFunctionComponent<Props> = ({ params, resetFormat }: Props) => {
  const { report_type: reportType, projectGroupId } = params;
  const baseUrl = `/projects/group/${projectGroupId}/reports`;

  return <Sidebar url={baseUrl} reportType={reportType} resetFormat={resetFormat} />;
};

export default ReleaseGroupLevelSidebar;
